
import { RegistereView } from "@eavfw/apps"

export const StatusColorComponent: React.FC = () => (
    <svg height="24" width="24" style={{ marginBottom: '5px' }}>
        <circle cx="12" cy="12" r="10" fill={'grey'} />
    </svg>
)
RegistereView("StatusColorComponent", StatusColorComponent);
